import { render, staticRenderFns } from "./RatingPerformanceLevelText.vue?vue&type=template&id=22a9bec0&"
import script from "./RatingPerformanceLevelText.vue?vue&type=script&lang=ts&"
export * from "./RatingPerformanceLevelText.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports